<script setup lang="ts">
import CenterModal from "~/components/Common/Modals/CenterModal.vue";
import AppButton from "~/components/Common/Buttons/AppButton.vue";

const emit = defineEmits(["delete", "cancel"]);

const deleteTimeslot = () => {
  emit("delete");
};

const cancel = () => {
  emit("cancel");
};
</script>

<template>
  <CenterModal class="max-w-[488px] w-full">
    <template #body>
      <div class="p-[24px] flex flex-col gap-3">
        <div class="flex flex-col gap-6">
          <div>
            <h3 class="heading_4_demi text-primary-color">Voulez-vous supprimer l’étape ?</h3>
            <p class="text-secondary-color mt-[6px] body_regular">Cette action ne sera pas modifiable.</p>
          </div>

          <div class="flex gap-[18px] gap w-full">
            <AppButton type="outlined" label="Annuler" class="w-full" @click="cancel" />
            <AppButton label="Supprimer" class="w-full" variant="error" @click="deleteTimeslot" />
          </div>
        </div>
      </div>
    </template>
  </CenterModal>
</template>

<style scoped></style>
